import React from 'react';
import { Dialog, DialogContent, CircularProgress, Typography } from '@mui/material';

const ActionProgressDialog = ({ open, message = "Please wait..." }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      transitionDuration={0}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(15, 23, 42, 0.4)',
            backdropFilter: 'blur(0.1875rem)',
          }
        },
        paper: {
          style: {
            borderRadius: '1.25rem',
            padding: '1.875rem 1.25rem',
            minWidth: '20rem',
            textAlign: 'center',
            boxShadow: '0 1.25rem 3.75rem rgba(4, 88, 100, 0.15), 0 0.5rem 1.25rem rgba(0, 0, 0, 0.08)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }
        }
      }}
    >
      <DialogContent sx={{ overflow: 'hidden', p: 0 }}>
        <CircularProgress size={56} sx={{ color: '#045864', mb: 3 }} thickness={4.5} />
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
          {message}
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b' }}>
          This might take a moment.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ActionProgressDialog;
